import React from 'react';
import { cx } from './cx';

/** Dense, accessible data table primitives (the "console" density agreed in the design review). */
export const Table = ({ caption, children, className }: { caption?: string; children?: React.ReactNode; className?: string }) => (
  <div className="overflow-x-auto">
    <table className={cx('w-full border-collapse text-sm', className)}>
      {caption && <caption className="sr-only">{caption}</caption>}
      {children}
    </table>
  </div>
);

export const Th = ({ children, numeric, className, ...rest }: React.ThHTMLAttributes<HTMLTableCellElement> & { numeric?: boolean }) => (
  <th
    scope="col"
    className={cx('border-b border-line bg-canvas px-4 py-2.5 text-[11px] font-bold uppercase tracking-wider text-muted', numeric ? 'text-right' : 'text-left', className)}
    {...rest}
  >
    {children}
  </th>
);

export const Td = ({ children, numeric, className, ...rest }: React.TdHTMLAttributes<HTMLTableCellElement> & { numeric?: boolean }) => (
  <td className={cx('border-b border-line/60 px-4 py-2.5 align-middle', numeric && 'text-right', className)} {...rest}>
    {children}
  </td>
);

export const ProgressBar = ({ value, label }: { value: number | string; label: string }) => {
  const pct = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <div className="flex min-w-[120px] items-center gap-2">
      <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-chip" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100} aria-label={label}>
        <div className="h-full rounded-full bg-brand-600" style={{ width: `${pct}%` }} />
      </div>
      <span className="w-9 text-xs text-muted">{pct}%</span>
    </div>
  );
};
